export const environment = {
  AppID: 20,
  host: 'https://dev.loctitepulse.henkelgroup.cloud/appbackend/',
  installation_agent_url: 'https://app-dev.loctite-pulse.com/ia',
  rm_parameter_key: 'cc_rm_param',
  debugMode: true,
  taskLimit: 4000,
  locale: 'en',
  debugAuth: false,
  href: '/em',
  appLogo: './assets/images/LoctitePulseLogo.svg',
  hasBusinessCentral: false,
  credentialLogin: true,
  portalLogin: false,
  msalLogin: true,
  msalPopup: false,
  msalClientID: 'c8647815-3dcc-4279-b0aa-95212693e302', // henkel
  msalIssuerService: 'https://login.microsoftonline.com/',
  msalIssuerServiceTenant: 'organizations',
  debugCredentials: null,
  // wp stuff:
  authorization_uri: '',
  redirect_uri: 'https://app-dev.loctite-pulse.com/em/login',
  logout_uri: 'https://www.ccsmartequipment.com/',
  client_id: 'cc_loctite_pulse',
  fakeTelemetry: false,
  //isTestInstance: true,
  environmentInstanceName: 'DEV',
  disableTabletView: false,
  disableSignup: false,
  disableSelectedSteamRateCurrency: false,
  appName: 'em',
  enableCaptcha: true,
  captchaSitekey: 'FCMP709RULE713A9',
  favicon: 'assets/feedback-dev.ico',
  prefix_equipment_monitor_uri: 'https://app-dev.loctite-pulse.com/em/',
  prefix_installation_agent_uri: 'https://app-dev.loctite-pulse.com/ia/',
};
